export default {
  /**
   * Kho bạc
   */
  Budget: 1,

  /**
   * Tiền mặt
   */
  Cashonhand: 2,

  /**
   * Tiền gửi
   */
  Cashinbank: 3,

  /**
   * Vật tư hàng hóa
   */
  Inventory: 4,

  /**
   * Tài sản cố định
   */
  Fixedasset: 5,

  /**
   * Tiền lương
   */
  Salary: 6,

  /**
   * Bán hàng
   */
  Sale: 7,

  /**
   * Mua hàng
   */
  Purchase: 8,

  /**
   * Thuế
   */
  Tax: 9,

  /**
   * Tổng hợp
   */
  Generalledger: 10,

  /**
   * Dự án
   */
  Project: 11,

  /**
   * Hoạt động sự nghiệp
   */
  Activity: 12,

  /**
   * Công cụ dụng cụ
   */
  Tool: 13,

  /**
   * Loại quỹ
   */
  Fund: 14,

  /**
   * Thanh toán vật tư sử dụng tại trạm y tế
   */
  Inventorysettlement: 15,

  /**
   * Đề tài
   */
  Topic: 16,

  /**
   * Chủ đầu tư
   */
  Investor: 17,

  /**
   * Nhiệm vụ
   */
  Task: 18,

  /**
   * Đặc thù VAAC
   */
  Vaac: 19,

  /**
   * Hóa đơn
   */
  Invoice: 20,

  /**
   * Hợp đồng
   */
  Contract: 21,
};
